export default __webpack_public_path__ + "static/media/billing-ss2.40c36630.png";